import styled from 'styled-components';

export const StyledRelationCodesDescriptions = styled.div`
   margin-top: 12px;
`;
StyledRelationCodesDescriptions.displayName = 'StyledRelationCodesDescriptions';
